import { combineReducers } from "redux";
import LoginReducer from "./Login/reducer";
import RegisterReducer from "./Register/reducer";
import hotelReducer from "./Hotel/reducer";


const rootReducer = combineReducers({
  login: LoginReducer,
  register:RegisterReducer,
    hotel: hotelReducer,
});

export default rootReducer;
